import styled, { css } from 'styled-components';

import { CommonAction, recipesCommonAction, styledTypography } from '@pkg/primitives';

interface StyledWalletButtonProps {
    $mobileNav?: boolean;
}

interface StatusPipProps {
    $mobileNav?: boolean;
    $status?: 'green' | 'red';
}

export const StyledWalletButton = styled(CommonAction)<StyledWalletButtonProps>`
    ${recipesCommonAction.blur};
    position: relative;
    flex-shrink: 0;
    gap: 8px;
    width: 40px;
    height: 40px;

    ${({ $mobileNav }) => {
        // Mobile nav styling matches 'Navigation/SidebarNav/NavButton'
        if ($mobileNav) {
            return css`
                justify-content: space-between;
                padding-left: 12px;
                padding-right: 12px;
                width: 100%;
                color: rgba(255, 255, 255, 0.5);
                background-color: rgba(255, 255, 255, 0.03);
                border: 1px solid transparent;
                border-radius: 10px;

                &:hover:not(:active) {
                    color: rgba(255, 255, 255, 1);
                    background-color: rgba(255, 255, 255, 0.06);
                    border-color: rgba(255, 255, 255, 0.05);
                }
            `;
        } else {
            return css`
                @media (min-width: 1440px) {
                    width: auto;
                    padding-left: 20px;
                    padding-right: 20px;
                }
            `;
        }
    }};
`;

export const IconWrapper = styled.div``;

export const Label = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    color: currentColor;
`;

export const StatusPip = styled.div<StatusPipProps>`
    position: absolute;
    top: 1px;
    right: 1px;
    width: 7px;
    height: 7px;
    background-color: #1dff26;
    border-radius: 100%;

    @media (min-width: 1440px) {
        position: static;
    }

    ${({ $status }) =>
        $status === 'red' &&
        css`
            background-color: #ff0000;
        `};

    ${({ $mobileNav }) =>
        $mobileNav &&
        css`
            position: static;
        `};
`;
